const app = {
  name: 'QHSE Adhi Karya',
  company: 'PT Adhi Karya (Persero) Tbk.',
  guide: 'https://drive.google.com/file/d/1aef8JO6G34y2FPAI_nGQ1QGTdZDpBNqf/view',
  site: 'https://qhse.adhi-info.com',
  logo: {
    sm: './static/img/logo/adhi/240x240.png',
    md: './static/img/logo/adhi/480x480.png',
    lg: './static/img/logo/adhi/720x720.png'
  },
  server: {
    stagging: 'https://qhse-adhi-v2.pttas.xyz/api',
    development: 'https://qhse-adhi-v2.pttas.xyz/api',
    production: 'https://qhse.adhi-info.com/api',
    demo: 'https://qhse-adhi-v2.pttas.xyz/api'
  },
  options: {
    allowRegister: true,
    forgetPassword: true
  }
}

export default app


// WEBPACK FOOTER //
// ./src/config.js